import React from 'react';
import {Button, FlexRow, Tooltip} from '@forecast-it/design-system';

export type CreateInvoiceFooterButton = {
	label: string;
	emphasis: 'high' | 'medium';
	onPress: () => void;
	disabled?: boolean;
	dataCy?: string;
	userpilot?: string;
	tooltip?: string | null;
};

type Props = {
	buttons: CreateInvoiceFooterButton[];
};

/** Primary action first, then the secondary, left-aligned like the design-system Modal footer. */
const CreateInvoiceFooter = ({buttons}: Props) => (
	<div style={{marginTop: 24}}>
		<FlexRow gap="s">
			{buttons.map(({label, emphasis, onPress, disabled, dataCy, userpilot, tooltip}) => {
				const button = (
					<span data-userpilot={userpilot}>
						<Button emphasis={emphasis} onPress={onPress} disabled={disabled} data-cy={dataCy}>
							{label}
						</Button>
					</span>
				);
				return tooltip ? (
					<Tooltip key={label} content={tooltip}>
						{button}
					</Tooltip>
				) : (
					<React.Fragment key={label}>{button}</React.Fragment>
				);
			})}
		</FlexRow>
	</div>
);

export default CreateInvoiceFooter;
